import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { UI } from "@wwimmo/ui";
import { Role } from "src/network/User";
import { BasicCommunicationSettings } from "src/screens/communicationSettings/basic/BasicCommunicationSettings";
import { PersonalCommunicationSettings } from "src/screens/communicationSettings/personal/PersonalCommunicationSettings";
import styles from "src/screens/communicationSettings/CommunicationSettings.module.css";

const GeneralCommunicationSettingsBase = (props: RouteComponentProps) => {
    const { t } = useTranslation();
    const { communicationSettingsStore, authStore } = useContext(RootStoreContext);
    const isAdministrator = authStore.user?.availableRoles?.includes(Role.ADMINISTRATOR);

    const onSave = async () => {
        await communicationSettingsStore.saveCommunicationSettings();
    };

    const onDiscard = () => {
        communicationSettingsStore.resetCommunicationSettings();
    };

    const saveSettingsButtonLabel = (
        <div className="d-flex align-items-center">
            <div>{t("labels.save")}</div>
            <UI.RotatingSpinner
                className={`${styles.SaveButtonSpinner} ${
                    communicationSettingsStore.isLoadingCommunicationSettings ? "" : "d-none"
                }`}
                noLogo={true}
                size={20}
            />
        </div>
    );

    return (
        <React.Fragment>
            {isAdministrator && <BasicCommunicationSettings />}
            <PersonalCommunicationSettings />
            <UI.Row>
                <UI.Col xl={9}></UI.Col>
                <UI.Col xl={3} className="d-flex justify-content-end align-items-center">
                    <UI.Button
                        onClick={onSave}
                        label={saveSettingsButtonLabel}
                        disabled={
                            communicationSettingsStore.isLoadingCommunicationSettings ||
                            !communicationSettingsStore.hasCommunicationSettingsChanged ||
                            communicationSettingsStore.hasValidationErrors
                        }
                    />
                    <UI.Button
                        label={t("labels.discard")}
                        disabled={!communicationSettingsStore.hasCommunicationSettingsChanged}
                        onClick={onDiscard}
                        className={"ml-2"}
                        variant="outline-primary"
                    />
                </UI.Col>
            </UI.Row>
        </React.Fragment>
    );
};

export const GeneralCommunicationSettings = withRouter(
    Sentry.withProfiler(observer(GeneralCommunicationSettingsBase))
);
